import { ComponentProps } from 'react';
import { DataGrid, GridFeatureMode } from '@mui/x-data-grid';

interface UseTablePaginationProps {
    pagination?: boolean;
    paginationMode?: GridFeatureMode;
    page?: number;
    setPage?: (page: number) => void;
    pageSize: number;
    setPageSize?: (pageSize: number) => void;
    pageSizeOptions?: number[];
}

export function useTablePagination({
    pagination = true,
    paginationMode = 'server',
    page,
    setPage,
    pageSize,
    setPageSize,
    pageSizeOptions,
}: UseTablePaginationProps) {
    const paginationModel =
        pagination && paginationMode === 'server' ? { page: page ? page - 1 : 0, pageSize } : undefined;

    const onPaginationModelChange =
        setPage && setPageSize
            ? ({ page, pageSize }: { page: number; pageSize: number }) => {
                  setPage(page + 1);
                  setPageSize(pageSize ?? 5);
              }
            : undefined;

    const paginationOptions: Partial<ComponentProps<typeof DataGrid>> = (() => {
        if (!pagination) return { hideFooter: true };

        return {
            pagination: true,
            paginationMode,
            pageSizeOptions: pageSizeOptions ?? [5, 10, 20],
            paginationModel,
            onPaginationModelChange,
        };
    })();

    return {
        paginationModel,
        onPaginationModelChange,
        paginationOptions,
    };
}
